// @ts-nocheck
/* eslint-disable */
export const menuOpenIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 12H10.6667V10.6667H2V12ZM2 8.66667H8.66667V7.33333H2V8.66667ZM2 4V5.33333H10.6667V4H2ZM14 10.3933L11.6133 8L14 5.60667L13.06 4.66667L9.72667 8L13.06 11.3333L14 10.3933Z" fill="currentColor"/></svg>`,
    name: 'menu-open' as const
};